import Service, { service } from '@ember/service';

export default class CopyEventService extends Service {
  @service store;
  adapter = this.store.adapterFor('favorite');

  async addToFavorite(item, modelName = undefined) {
    try {
      const id = item.id;
      const type = modelName ?? item.get('constructor.modelName');
      await this.adapter.addToFavorite({ id, type });
      const record = this.store.peekRecord(type, id);
      record.favorite = true;
    } catch (err) {
      console.error(err, 'Could not add to favorites');
    }
  }

  async removeFromFavorite(item, modelName = undefined) {
    try {
      const id = item.id;
      const type = modelName ?? item.get('constructor.modelName');
      await this.adapter.removeFromFavorite({ id, type });
      const record = this.store.peekRecord(type, id);
      record.favorite = false;
    } catch (err) {
      console.error(err, 'Could not add to favorites');
    }
  }
}
